export default "__VITE_ASSET__DHvMqSb8__"